import request from '@/service/request'

export const getAgentPage = (params: COMMON.API.QueryParams) => {
  return request<SERVICE.ResponsePage<COMMON.AGENT[]>>({
    url: '/admin/mpAgent',
    method: 'GET',
    params,
    headers: {
      platform: 'home'
    }
  })
}

export const delAgentById = (id: string) => {
  return request<SERVICE.Response<string>>({
    url: `/admin/mpAgent/${id}`,
    method: 'DELETE',
    headers: {
      platform: 'home'
    }
  })
}

export const getAgentById = (id: string) => {
  return request<SERVICE.Response<string>>({
    url: `/admin/mpAgent/${id}`,
    method: 'GET',
    headers: {
      platform: 'home'
    }
  })
}

export const addAgent = (data: COMMON.AGENT) => {
  return request<SERVICE.Response<string>>({
    url: '/admin/mpAgent',
    method: 'POST',
    data,
    headers: {
      platform: 'home'
    }
  })
}

export const upadteAgent = (data: COMMON.AGENT) => {
  return request<SERVICE.Response<string>>({
    url: '/admin/mpAgent',
    method: 'PUT',
    data,
    headers: {
      platform: 'home'
    }
  })
}
